import React, { ReactElement } from 'react'
import { AcctDetailsItem, Dd, Dt } from './StyledDlElements'

interface StandardDlProps {
  title: string
  definition: string | number | ReactElement
}

export const StandardDl: React.FC<StandardDlProps> = ({
  title,
  definition,
}) => {
  return (
    <AcctDetailsItem>
      <Dt>{title}</Dt>
      <Dd>{definition}</Dd>
    </AcctDetailsItem>
  )
}
